// extracted by mini-css-extract-plugin
export default {"skincare":"RightSide_skincare__7TSyN","header":"RightSide_header__9WsFM","sort":"RightSide_sort__QYseC"};